import React from 'react';
import './Match.css';
import { useSelector, useDispatch } from 'react-redux';
import * as matchActions from '../../../redux/actions/matchActions';
import MatchHeader from '../../../components/mobile/MatchHeader/MatchHeader';
import MatchSetPoints from '../../../components/mobile/MatchSetPoints/MatchSetPoints';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

function Match() {
    const { selectedMatch } = useSelector((state) => state.match);
    const dispatch = useDispatch();

    return (
        <div className='match-page'>
            <button className='match-back-btn' onClick={() => dispatch(matchActions.releaseSelectedMatch())}>
                <span>חזרה</span>
                <ChevronLeftIcon fontSize='small' />
            </button>
            <MatchHeader matchDetails={selectedMatch} />
            <MatchSetPoints selectedMatch={selectedMatch} />
        </div>
    );
}

export default Match;
